<template>
    <div class="orderPage">
        <div class="selection_list" v-if="orderList.length">
            <!-- 听力单项考试 -->
            <div
                class="selection_item"
                v-for="item in orderList"
                :key="item.id"
            >
                <p style="margin-bottom: 8px; font-size: 14px">{{ item.code }}</p>
                <div class="item_header">
                    <span class="item_title" v-if="item">
                        {{
                            currentLocale === "zh-CN"
                                ? item.examTitle
                                : item.examTitleEn
                        }}
                    </span>
                    <div class="checkbox_wrapper">
                        <!-- 已支付 -->
                         <span
                            v-if="item.status === 2 && item.refundStatus !== 1"
                            class="checkbox_icon"
                            >
                            <img class="icon"
								src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/miniprogram/u134.png"
								/>
                            {{
                                currentLocale === 'zh-CN' ? '线下机考' : 'In-Person Computer-Based'
                            }}</span
                        >
                        <span
                            v-if="item.status === 1"
                            class="checkbox_wrapper1"
                            >{{
                                currentLocale === "zh-CN"
                                    ? "待支付"
                                    : "Pending payment"
                            }}</span
                        >
                        <span v-if="item.status === 3">{{
                            currentLocale === "zh-CN" ? "已过期" : "Expired"
                        }}</span>
                        <span v-if="item.status === 4">{{
                            currentLocale === "zh-CN"
                                ? "已退考"
                                : "Retired from the exam"
                        }}</span>
                        <span
                            v-if="item.status === 6"
                            class="checkbox_wrapper2"
                            >{{
                                currentLocale === "zh-CN"
                                    ? "已取消"
                                    : "Cancelled"
                            }}</span
                        >
                        <span v-if="item.refundStatus === 1">
                            {{   currentLocale === "zh-CN"
                                ? "退款中"
                                : "Refunding" }}
                        </span>
                    </div>
                </div>
                <p class="item_description">
                    <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/定位.png" alt="">
                    {{ $t("order.examinationPoint") }}：
                    {{
                        currentLocale === "zh-CN"
                            ? item.positionInfo.exam_point.name
                            : item.positionInfo.exam_point.nameEn
                    }}
                </p>
                <p class="item_condition">
                    <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/时长.png" alt=""></img>
                    {{
                        currentLocale === "zh-CN"
                            ? formatChinese(item.positionInfo.examTime)
                            : formatEnglish(item.positionInfo.examTime)
                    }}
                    {{
                        currentLocale === "zh-CN"
                            ? item.positionInfo.sessions
                            : item.positionInfo.sessionsEn
                    }}
                </p>
                <span v-if="item.invoiceInfo && item.invoiceInfo.rejectReason" style="word-break: break-all;border: none;color:red;justify-content: flex-end;">
                    <i slot="reference" class="el-icon-question"></i>
                        {{ item.invoiceInfo.rejectReason }}
                </span>
                <div class="item-detail" @click="lookDetail(item)">
                 <!-- 开票相关 -->
                   <!-- <span v-if="item.invoiceInfo && item.invoiceInfo.rejectReason" style="max-width:120px;word-break: break-all;border: none;color:red;justify-content: flex-end;">
                        <i slot="reference" class="el-icon-question"></i>
                        {{ item.invoiceInfo.rejectReason }}
                    </span> -->
                    <el-button 
                        v-if="item.status === 2 && (item.invoiceStatus === 0 || item.invoiceStatus === 4 || !item.invoiceStatus) && getInvoiceTime(item) && item.finalPrice !==0"
                       @click.stop="openInvoiceModal(item)"
                       class="apply-btn3"
                       >
                            <span v-if="item.invoiceStatus === 0 || !item.invoiceStatus">
                                {{currentLocale == 'zh-CN' ? '去开票' :'issue an invoice'}}
                            </span>
                            <span v-if="item.invoiceStatus === 4">
                                                               
                                {{currentLocale == 'zh-CN' ? '重新开票' :'Reissue the invoice'}}
                            </span>
                    </el-button>
                    <el-button 
                        v-if="item.status === 4 && item.invoiceStatus === 4"
                       @click.stop="openInvoiceModal(item)"
                       class="apply-btn3"
                       >
                            <span v-if="item.invoiceStatus === 4">
                                                               
                                {{currentLocale == 'zh-CN' ? '重新开票' :'Reissue the invoice'}}
                            </span>
                    </el-button>
                    <el-button 
                        v-if="item.hasPaidRefund && item.invoiceStatus === 0 && item.finalPrice !==0"
                       @click.stop="openInvoiceModal(item)"
                       class="apply-btn3"
                       >
                            <span>
                                {{currentLocale == 'zh-CN' ? '去开票' :'issue an invoice'}}
                            </span>
                    </el-button>
                    <p class="apply-btn"  v-if="item.invoiceStatus === 3 && item.invoiceUrl"
						@click.stop="goInvoiceDetail(item)">
							{{currentLocale == 'zh-CN' ? '下载发票' :'Download invoice'}}
					</p>
					<p class="apply-btn apply-btn1"  style="border: none;color:green;hover:none"  @click.stop="" v-if="item.invoiceStatus === 3 && !item.invoiceUrl"
						>
							{{currentLocale == 'zh-CN' ? '已开票' :'Invoice issued details'}}
					</p>
                    <p class="apply-btn apply-btn1" v-if="item.invoiceStatus === 1" @click.stop="" style="border: none;color:green">
                        {{currentLocale == 'zh-CN' ? '开票中' : 'Invoicing in progress'}}
                    </p>
                    <!--  -->
                    <span v-if="item.status === 2">
                        <!-- 查看考位 -->
                        {{ $t("order.btnOne") }}
                    </span>
                    <span
                        v-if="
                            item.status === 6 ||
                            item.status === 3 ||
                            item.status === 4
                        "
                    >
                        {{
                            currentLocale == "zh-CN" ? "查看订单" : "View Order"
                        }}
                    </span>
                    <span v-if="item.status === 1" style="border: none;color:red">
                        {{ $t("order.deadline")}}{{ countdownMap[item.id] || "00:00:00" }}
                    </span>
                    <el-button
                        class="pay-btn"
                        v-if="item.status === 1"
                        style="color:#fff;border: 1px solid red;background-color: red;"
                        :disabled="
                            !countdownMap[item.id] ||
                            countdownMap[item.id] === '00:00:00'
                        "
                        :class="{
                            'disabled-btn':
                                !countdownMap[item.id] ||
                                countdownMap[item.id] === '00:00:00',
                        }"
                        @click.stop="goPayMent(item)"
                        >{{ $t("order.pay") }}{{ item.finalPrice }}</el-button
                    >
                </div>
            </div>
            <!-- <div
                class="selection_item"
                :class="{
                    'selection_item--active':
                        selected_exams.includes('speaking'),
                }"
            >
                <div class="item_header">
                    <span class="item_title">口语单项考试</span>
                    <div class="checkbox_wrapper checkbox_wrapper1">未支付</div>
                </div>
                <p class="item_description">选择此项即意味着单独报名口语考试</p>
                <p class="item_condition">适用于16岁及以上的学习者</p>
            </div> -->
        </div>
        <!-- 查看考位 -->
        <Modal
            :showModal="showModal1"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-submit="false"
            :show-delete-icon="true"
            show-size="big"
            @confirm="handleConfirm"
            @cancel="handleCancel"
        >
            <template #content>
                <examSeatDetailModal :orderId="orderId" @closeModal="closeModal" />
            </template>
            <template #footer>
                <!-- <button class="btn-submit" @click="submitCustom">提交申请</button> -->
            </template>
        </Modal>

        <!-- 开票弹窗 -->
        <el-dialog
            v-if="showInvoiceModal"
            :visible.sync="showInvoiceModal"
            :width="isMobile ? '95%' : '680px'"
            :title="currentLocale === 'zh-CN' ? '开具发票' : 'Apply for Invoice'"
            :close-on-click-modal="false"
        >
            <div class="invoice_content">
                <!-- 开票金额 -->
                <div class="invoice_amount">
                    <h4>{{ currentLocale === 'zh-CN' ? '开票金额' : 'Invoice Amount' }}</h4>
                    <div class="amount_row">
                        <div class="amount_item">
                            <span>{{ currentLocale === 'zh-CN' ? '报名费' : 'Registration Fee' }}</span>
                            <span>¥{{ invoiceAmount.registrationFee}}</span>
                        </div>
                        <div class="amount_item">
                            <span>{{ currentLocale === 'zh-CN' ? '手续费' : 'Service Fee' }}</span>
                            <span>¥{{ invoiceAmount.serviceFee }}</span>
                        </div>
                        <div class="amount_item">
                            <span>{{ currentLocale === 'zh-CN' ? '开票总额' : 'Total Amount' }}</span>
                            <span style="font-weight: 700; color: red">¥{{ invoiceAmount.total }}</span>
                        </div>
                    </div>
                </div>

                <!-- 开票详情 -->
                <div class="invoice_detail">
                    <h4>{{ currentLocale === 'zh-CN' ? '开票详情' : 'Invoice Details' }}</h4>
                    
                    <!-- 抬头类型 -->
                    <div class="form_row">
                        <label class="form_label">{{ currentLocale === 'zh-CN' ? '抬头类型' : 'Title Type' }}</label>
                        <div class="radio_group">
                            <label class="radio_item">
                                <input type="radio" v-model="invoiceForm.titleType" value="0" />
                                <span>{{ currentLocale === 'zh-CN' ? '企业单位' : 'Company' }}</span>
                            </label>
                            <label class="radio_item">
                                <input type="radio" v-model="invoiceForm.titleType" value="1" />
                                <span>{{ currentLocale === 'zh-CN' ? '个人/非企业' : 'Individual/Non-Enterprise' }}</span>
                            </label>
                        </div>
                    </div>

                    <!-- 发票信息表格 -->
                    <div class="invoice_table">
                        <!-- 发票抬头（个人和企业都显示） -->
                        <div class="form_group" :style="{'grid-template-columns': invoiceForm.titleType === '1' || isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}">
                            <div class="form_item">
                                <label class="form_label">{{ currentLocale === 'zh-CN' ? '发票抬头' : 'Invoice Title' }}</label>
                                <el-input
                                    v-model="invoiceForm.title"
                                    :placeholder="currentLocale === 'zh-CN' ? '填写发票抬头(必填)' : 'Enter invoice title'"
                                    class="form_input_small"
                                    :style="{'width': invoiceForm.titleType === 'personal' ? '100%' : ''}"
                                ></el-input>
                            </div>

                            <!-- 企业单位专属字段 -->
                            <template v-if="invoiceForm.titleType === '0'">
                                <!-- 公司税号 -->
                                <div class="form_item">
                                    <label class="form_label">{{ currentLocale === 'zh-CN' ? '公司税号' : 'Tax Number' }}</label>
                                    <el-input
                                        v-model="invoiceForm.taxNo"
                                        :placeholder="currentLocale === 'zh-CN' ? '填写纳税人识别号(必填)' : 'Enter tax number'"
                                        class="form_input_small"
                                    ></el-input>
                                </div>
                                <template  v-if="invoiceForm.titleType === '0' && expanded">
                                     <!-- 公司地址 -->
                                <div class="form_item">
                                    <label class="form_label">{{ currentLocale === 'zh-CN' ? '公司地址' : 'Company Address' }}</label>
                                    <el-input
                                        v-model="invoiceForm.address"
                                        :placeholder="currentLocale === 'zh-CN' ? '填写公司地址(选填)' : 'Enter company address'"
                                        class="form_input_small"
                                    ></el-input>
                                </div>

                                <!-- 公司电话 -->
                                <div class="form_item">
                                    <label class="form_label">{{ currentLocale === 'zh-CN' ? '公司电话' : 'Company Phone' }}</label>
                                    <el-input
                                        v-model="invoiceForm.phone"
                                        :placeholder="currentLocale === 'zh-CN' ? '填写公司电话(选填)' : 'Enter company phone'"
                                        class="form_input_small"
                                    ></el-input>
                                </div>

                                <!-- 开户银行 -->
                                <div class="form_item">
                                    <label class="form_label">{{ currentLocale === 'zh-CN' ? '开户银行' : 'Bank Name' }}</label>
                                    <el-input
                                        v-model="invoiceForm.bank"
                                        :placeholder="currentLocale === 'zh-CN' ? '填写开户银行(选填)' : 'Enter bank name'"
                                        class="form_input_small"
                                    ></el-input>
                                </div>

                                <!-- 开户账号 -->
                                <div class="form_item">
                                    <label class="form_label">{{ currentLocale === 'zh-CN' ? '开户账号' : 'Bank Account' }}</label>
                                    <el-input
                                        v-model="invoiceForm.bankAccount"
                                        :placeholder="currentLocale === 'zh-CN' ? '填写开户账号(选填)' : 'Enter bank account'"
                                        class="form_input_small"
                                    ></el-input>
                                </div>
                                </template>
                               
                            </template>
                        </div>
                        <div @click="toggleExpand" v-if="invoiceForm.titleType === '0'" style="text-align:center">
                            <span class="toggleExpand">
                                {{ currentLocale === 'zh-CN' ? '展开选填信息（住址、电话等）' : 'Expand optional information (address, phone, etc.)' }}
                                </span>
                            <span class="toggleExpand">{{expanded ? '▲' : '▼'}}</span>
                        </div>
                    </div>
                </div>

                <!-- 接收方式 -->
                <div class="receive_method">
                    <h4>{{ currentLocale === 'zh-CN' ? '接收方式' : 'Receiving Method' }}</h4>
                    <div class="form_row" style="display: flex;flex-flow:row;align-items: center;">
                        <label class="form_label" style="min-width:80px">{{ currentLocale === 'zh-CN' ? '电子邮箱' : 'Email' }}</label>
                        <el-input
                            v-model="invoiceForm.email"
                            :placeholder="currentLocale === 'zh-CN' ? '填写电子邮箱(必填)' : 'Enter email address (required)'"
                            class="form_input_small"
                        ></el-input>
                    </div>
                </div>
            </div>

            <div slot="footer" class="dialog_footer">
                <el-button @click="closeInvoiceModal">
                    {{ currentLocale === 'zh-CN' ? '取消' : 'Cancel' }}
                </el-button>
                <el-button type="primary" @click="submitInvoice">
                    {{ currentLocale === 'zh-CN' ? '确定' : 'Submit' }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from "vue";
import { getOrderRescource, getApplyInvoiceStatus, setApplyInvoice} from "@/plugins/api";
import { toCST, formatChinese, formatEnglish, getYear, getMonth, getDay } from "@/utils/date";
// import examSeatModal from "@/components/examSeatModal.vue";
import examSeatDetailModal from "@/components/examSeatDetailModal.vue";

export default Vue.extend({
    data() {
        return {
            showModal: false,
            showModal1: false,
            showInvoiceModal: false,
            currentLocale: "zh-CN",
            orderList: [],
            isScroll: false,
            status: "考试订单 ",
            radio1: 0,
            selected: "",
            selectAged: false,
            options: [],
            navHeight: 0, // 添加导航栏高度变量
            countdownMap: {}, // { orderId: '00:00:00' }
            timerMap: {},
            orderId: null,
            currentOrder: null,
            invoiceForm: {
                titleType: '0', // company: 企业单位, personal: 个人/非企业
                title: '', // 发票抬头
                taxNo: '', // 公司税号
                address: '', // 公司地址
                phone: '', // 公司电话
                bank: '', // 开户银行
                bankAccount: '', // 开户账号
                email: '' // 电子邮箱
            },
            invoiceAmount: {
                registrationFee: 0, // 报名费
                serviceFee: 0, // 手续费
                total: 0 // 开票总额
            },
            expanded: false, // 控制选填信息展开
            isMobile: false, // 是否为移动端

        };
    },
    props: {},
    components: { examSeatDetailModal },
    mounted() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    computed: {},
    created() {
        this.currentLocale = this.$i18n.locale || "zh-CN";
        this.getOrderList();
    },
    watch: {
        "$i18n.locale": {
            handler(newVal) {
                // console.log('语言变化:', newVal);
                this.currentLocale = newVal || "zh-CN";
            },
            immediate: true,
        },
       "invoiceForm.titleType": {
            handler(newVal) {
               this.invoiceForm = {
                    titleType: newVal,
                    title: '',
                    taxNo: '',
                    address: '',
                    phone: '',
                    bank: '',
                    bankAccount:'',
                    email: ''
                }
            },
            immediate: true
        }
    },
    methods: {
        handleConfirm() {},
        handleCancel() {
            this.showModal1 = false;
        },
        closeModal (result) {
             this.showModal1 = result
             this.getOrderList()
        },
        goPayMent(item) {
            this.$router.push({
                path: "/nopayOrder",
                    query: {
                        orderId: item.id,
                        status: item.status,
                },
            });
        },
        lookDetail(item) {
            if (item.status === 2) {
                this.showModal1 = true;
                this.orderId = item.id
            } else {
                // 在实际应用中，这里应该发送数据到后端API
                this.$router.push({
                    path: "/nopayOrder",
                    query: {
                        orderId: item.id,
                        status: item.status,
                    },
                });
                // this.$router.push({
                //     path: "/orderDetail",
                //     query: {
                //         orderId: item.id,
                //     },
                // });
            }
        },
        // 获取订单数据
        async getOrderList() {
            // 1: '待支付',
            // 2: '已支付',
            //3: '已过期',
            //4: '已退考',
            //5: '部分支付',
            //6: '已取消',
            const res = await getOrderRescource();
            // console.log(res, '++++ssss')
            // this.orderList = res.filter(item => item.status === 1 || item.status === 2 || item.status === 6);
            this.orderList = res;
            // 清理旧定时器
            Object.values(this.timerMap).forEach((timer) =>
                clearInterval(timer)
            );
            this.timerMap = {};
            this.countdownMap = {};

            this.orderList.forEach((item) => {
                if (item.status === 1 && item.expiretime) {
                    this.startCountdown(item.id, item.expiretime);
                    // 为了测试订单超时，写死三分钟
                    // const testExpireTime = new Date(Date.now() + 180000).toISOString(); // 当前时间+3分钟
                    // this.startCountdown(item.id, testExpireTime);
                }
            });
        },
        startCountdown(orderId, expiretime) {
            const update = () => {
                const now = toCST(Date.now()).valueOf();
                const end = toCST(expiretime).valueOf();
                const diff = end - now;
                // console.log(diff);
                this.$set(
                    this.countdownMap,
                    orderId,
                    this.formatCountdown(diff)
                );
                if (diff <= 0 && this.timerMap[orderId]) {
                    clearInterval(this.timerMap[orderId]);
                    this.timerMap[orderId] = null;
                }
            };
            update();
            this.timerMap[orderId] = setInterval(update, 1000);
        },
        formatCountdown(ms) {
            if (ms <= 0) return "00:00:00";
            const totalSeconds = Math.floor(ms / 1000);
            const hours = String(Math.floor(totalSeconds / 3600)).padStart(
                2,
                "0"
            );
            const minutes = String(
                Math.floor((totalSeconds % 3600) / 60)
            ).padStart(2, "0");
            const seconds = String(totalSeconds % 60).padStart(2, "0");
            return `${hours}:${minutes}:${seconds}`;
        },
        // 添加新方法
        getDescList(examInfo) {
            const desc =
                this.currentLocale === "zh-CN"
                    ? examInfo.examTitle
                    : examInfo.examTitleEn;
            return desc.split("\n").filter((item) => item.trim());
        },
        // 打开开票弹窗
        openInvoiceModal(item) {
            this.currentOrder = item;
            // 设置开票金额（模拟数据，实际应从订单数据获取）
            getApplyInvoiceStatus(item.id).then(res=>{
                    this.invoiceAmount = {
                        registrationFee: res.order.finalPrice,
                        serviceFee: res.transferFee,
                        total:  res.invoiceTotalAmount,
                    };
                // 重置表单
                this.invoiceForm = {
                    titleType: '0',
                    title: '',
                    taxNo: '',
                    address: '',
                    phone: '',
                    email: ''
                };
                this.expanded = false;
                this.showInvoiceModal = true;
			})
        },
        goInvoiceDetail(item){
            if(!item.invoiceUrl) return
            const invoiceUrl = item.invoiceUrl.replace('http://', 'https://');
                window.open(
                invoiceUrl,
                "_blank"
                );
		},
        // 关闭开票弹窗
        closeInvoiceModal() {
            this.showInvoiceModal = false;
            this.currentOrder = null;
        },
        // 检测是否为移动端
        checkMobile() {
            this.isMobile = window.innerWidth <= 640;
        },
        // 切换展开状态
        toggleExpand() {
            this.expanded = !this.expanded;
        },
        getInvoiceTime(item) {
            const now = toCST(Date.now()).valueOf();
            const expire = toCST(item.positionInfo.examTime).valueOf();
            const threeDaysLater = expire + 3 * 24 * 60 * 60 * 1000;
            return now > threeDaysLater;
        },
        // 提交开票申请
        async submitInvoice() {
            // 表单验证
            if (!this.invoiceForm.title.trim()) {
                this.$message.warning(this.currentLocale === 'zh-CN' ? '请填写发票抬头' : 'Please enter invoice title');
                return;
            }
            if (this.invoiceForm.titleType === '0' && !this.invoiceForm.taxNo.trim()) {
                this.$message.warning(this.currentLocale === 'zh-CN' ? '请填写公司税号' : 'Please enter tax number');
                return;
            }
            if (!this.invoiceForm.email.trim()) {
                this.$message.warning(this.currentLocale === 'zh-CN' ? '请填写电子邮箱' : 'Please enter email address');
                return;
            }
            const email = this.invoiceForm.email.trim();
			const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			if (!emailReg.test(email)) {
                this.$message.error(this.currentLocale === 'zh-CN' ? '邮箱格式不正确' : 'The email format is incorrect');
				return;
			}
            
            // 模拟提交开票申请
            this.$loading({
                lock: true,
                text: this.currentLocale === 'zh-CN' ? '提交中...' : 'Submitting...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const parmdata = {...this.invoiceForm}
				for (let key in parmdata) {
					const val = parmdata[key];
					if (val === '' || val === null || val === undefined) {
					    delete parmdata[key];
					}
				}
            parmdata.orderId = this.currentOrder.id
            try {
                await setApplyInvoice(parmdata);
                setTimeout(() => {
                    this.$loading().close();
                    this.$message.success(this.currentLocale === 'zh-CN' ? '开票申请已提交，发票将发送至您的邮箱' : 'Invoice application submitted. The invoice will be sent to your email.');
                    this.closeInvoiceModal();
                    this.getOrderList()
                }, 1500);
            } catch (error) {
                console.log(error)
                this.$loading().close();
            }
        },
    },
    beforeDestroy() {},
});
</script>
<style lang="stylus" scoped>
$pay-color = #011E41;
$calcel-color = #666666;
$nopay-color = #CA0000;

.orderPage {
    height: calc(100vh - 200px);
    margin: 24px 0 0px 0;

    .selection_list {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
        gap: 20px;
        padding: 0 0 20px 0;

        @media (max-width: 640px) {
            grid-template-columns: 1fr;
        }

        // }
        .selection_item {
            // width: 50%;
            background-color: #fff;
            // border: 2px solid #e0e0e0;
            border-radius: 10px;
            padding: 26px 24px;
            cursor: pointer;
            transition: all 0.3s ease;
            position: relative;
            padding-bottom: 56px;
            &:hover {
                border-color: #409eff;
                box-shadow: 0 4px 12px rgba(64, 158, 255, 0.1);
            }

            &--active {
                border-color: #409eff;
                background-color: #f0f9ff;
            }

            .item_header {
                display: flex;
                flex-flow: row;
                align-items: center;
                margin-bottom: 18px;
                justify-content: space-between;
                position: relative;
                padding-bottom: 20px;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    background-color: #e0e0e0;
                    z-index: 1;
                    height: 4px;
                    background: linear-gradient(90deg, #E2CB24 0%, #50B9AA 100%);
                }

                .checkbox_wrapper {
                    font-size: 18px;
                    color: #011E41;
                    .checkbox_icon {
                        display: flex;
                        flex-flow: row;
                        align-items: center;
                    }
                    img {
                        width: 26px;
                        height: 26px;
                    }
                }

                .checkbox_wrapper1 {
                    color: $nopay-color;
                }

                .checkbox_wrapper2 {
                    color: $calcel-color;
                }

                .item_title {
                    font-weight: bold;
                    font-size: 22px;
                    color: #011E41;
                    line-height: 33px;
                }
            }

            .item_description, .item_condition {
                font-weight: 400;
                font-size: 18px;
                color: #011E41;
                line-height: 30px;
                display: flex;
                flex-flow: row;
                align-items: center;
            }

            .item_description img, .item_condition img {
                width: 16px;
                // height: 16px;
                margin-right: 8px;
            }

            .item-detail {
                position: absolute;
                bottom: 10px;
                right: 10px;
                z-index: 1;
                display: flex;
                flex-flow: row;
                // align-items: center;
                justify-content: flex-end;
                margin-top: 12px;

                >span, >>>.el-button, > p {
                    min-width: 140px;
                    padding: 8px 18px;
                    border-radius: 22px;
                    border: 1px solid #0043E0;
                    display: flex;
                    flex-flow: row;
                    align-items: center;
                    justify-content: center;
                    color: #0043E0;
                    font-size: 14px;
                }
                .apply-btn3 {
                    background-color: #C9D8E3;
                    color: #002248;
                    margin-right: 8px;
                    border: none;
                }
                .apply-btn {
                    margin-right: 8px;
                }
            }
        }
    }
}

@media (max-width: 640px) {
    .orderPage {
        margin: 4vw 0 12vw 0;
        height: calc(100vh - 40vh);
        .selection_list {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
            gap: 6vw;

            .selection_item {
                border-radius: 10px;
                // padding: 4vw 3.8vw;

                .item_header {
                    margin-bottom: 3vw;
                    padding-bottom: 2vw;

                    &::after {
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        z-index: 1;
                        height: 4px;
                    }

                    .checkbox_wrapper {
                        font-size: 3.2vw;
                    }

                    .item_title {
                        font-size: 4vw;
                        line-height: 33px;
                    }
                }

                .item_description, .item_condition {
                    font-size: 3.4vw;
                    line-height: 5vw;
                }

                .item_description img, .item_condition img {
                    width: 3.2vw;
                    // height: 1.2vw;
                    margin-right: 1vw;
                }

                .item-detail {
                    display: flex;
                    flex-flow: row;
                    justify-content: flex-end;

                    >span, .el-button, >p {
                        min-width: 26vw;
                        padding: 1.8vw 3.6vw;
                        border-radius: 6vw;
                        font-size: 3.2vw;
                    }
                    .apply-btn {
                        margin-right: 1.8vw;
                    }
                }
            }
        }
    }
}

// 开票弹窗样式
.invoice_content {
    padding: 10px 0;
    >>> .el-input .el-input__inner, .el-select .el-input__inner {
            background: #fff;
        }
}

.invoice_amount, .invoice_detail, .receive_method {
    margin-bottom: 20px;
    padding: 15px;
    // background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #dcdfe6;

    h4 {
        margin-bottom: 15px;
        font-weight: bold;
        color: #303133;
        font-size: 16px;
    }
}

.amount_row {
    display: flex;
    justify-content: space-between;
    // flex-wrap: wrap;
}

.amount_item {
    width: 32%;
    display: flex;
    // justify-content: space-between;
    padding: 8px 0;
    align-items: center;
    font-size: 14px;
    color: #606266;
    gap: 16px;
    &.amount_total {
        width: 100%;
        border-top: 1px dashed #dcdfe6;
        margin-top: 10px;
        padding-top: 15px;
        font-weight: bold;
        color: #303133;
        font-size: 16px;
    }
}

.form_row {
    margin-bottom: 15px;

    &:last-child {
        margin-bottom: 0;
    }
    
}

.form_label {
    display: block;
    // margin-bottom: 8px;
    font-size: 14px;
    color: #606266;
}

.form_input {
    width: 100%;
}

.form_input_small {
    ::v-deep .el-input__inner {
        width: 100%;
        height: 30px !important;
        font-size: 13px;
        border-radius: 4px;
        border: none;
    }
}

.form_row_double {
    display: flex;
    gap: 15px;
    margin-bottom: 15px;

    .form_item {
        flex: 1;
        min-width: 0;
    }
}

.invoice_table {
    width: 100%;

    .form_group {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        // gap: 15px;
        padding: 10px 0;
    }

    .form_item {
        display: flex;
        flex-direction: row;
        align-items: center;
        // gap: 8px;
        border-bottom: 1px solid #ededed;
        margin-bottom: 12px;
        .form_label {
            font-size: 14px;
            color: #606266;
            font-weight: 500;
            min-width: 80px;
        }
        
    }

}

@media (max-width: 640px) {
    .invoice_table {
        .form_group {
            grid-template-columns: 1fr;
            gap: 12px;
        }
    }
}

.radio_group {
    display: flex;
    gap: 20px;
}

.radio_item {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: #606266;

    input[type="radio"] {
        margin-right: 6px;
    }
}

.expand_section {
    margin-top: 10px;

    .expand_btn {
        padding: 0;
        color: #409EFF;
        font-size: 13px;
    }

    .expand_content {
        margin-top: 15px;
        padding-top: 15px;
        border-top: 1px dashed #dcdfe6;
    }
}

.dialog_footer {
    text-align: right;

    .el-button {
        min-width: 80px;
        margin-left: 10px;
    }
}

@media (max-width: 640px) {
    .amount_row {
        flex-direction: column;
    }

    .amount_item {
        min-width: 100%;
        justify-content: space-between;
    }

    .radio_group {
        flex-direction: row;
        gap: 10px;
    }
}
</style>